const _temp0 = require("url:./assets/media/thumbs/2026.08.04-fruit-seller-chased.webp");

const _temp1 = require("url:./assets/media/thumbs/2026.08.20-human-safari-bus-attack.webp");

const _temp2 = require("url:./assets/media/thumbs/Andrushenko, FPV drone.webp");

const _temp3 = require("url:./assets/media/thumbs/Andrushenko, human safari.webp");

module.exports = {
  "2026.08.04-fruit-seller-chased":   {
    "webp": _temp0
  },
  "2026.08.20-human-safari-bus-attack":   {
    "webp": _temp1
  },
  "Andrushenko, FPV drone":   {
    "webp": _temp2
  },
  "Andrushenko, human safari":   {
    "webp": _temp3
  }
}